// @ts-strict-ignore
export const log = {
  // ...args: any because console.info(...) receives ...args: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  info: (...args: any) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'trackJs' does not exist on type 'Window ... Remove this comment to see the full error message
    if (window.trackJs) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'trackJs' does not exist on type 'Window ... Remove this comment to see the full error message
      window.trackJs.console.info(...args);
    } else if (window.console && window.console.info) {
      // eslint-disable-next-line no-console
      console.info(...args);
    }
  },
  // ...args: any because console.error(...) receives ...args: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: (...args: any) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'trackJs' does not exist on type 'Window ... Remove this comment to see the full error message
    if (window.trackJs) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'trackJs' does not exist on type 'Window ... Remove this comment to see the full error message
      window.trackJs.console.error(...args);
    } else if (window.console && window.console.error) {
      // eslint-disable-next-line no-console
      console.error(...args);
    }
  },
};
